var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "black",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16362 12.4962L6.18824 11.9968C6.2241 11.9986 6.26005 11.9879 6.29008 11.9656L11.9107 6.27999C11.9537 6.21362 11.9467 6.12405 11.8927 6.06565L6.16362 12.4962ZM6.16362 12.4962L6.13426 11.9971C6.10006 11.9991 6.0657 11.9897 6.03641 11.9699C5.98395 11.9023 5.98818 11.8026 6.04909 11.7403C6.04921 11.7401 6.04933 11.74 6.04945 11.7399L11.6703 6.05405C11.7354 5.99643 11.8326 6.00064 11.8927 6.06565L6.16362 12.4962Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7856 12.4964L11.838 11.9991C11.8782 12.0034 11.9191 11.9919 11.9522 11.9658C11.9526 11.9654 11.953 11.965 11.9534 11.9645L11.7856 12.4964ZM11.7856 12.4964L11.7877 11.9964C11.7469 11.9962 11.7067 11.9799 11.676 11.9494C11.6758 11.9492 11.6757 11.9491 11.6755 11.9489L6.06527 6.27378C6.01254 6.20106 6.02413 6.0975 6.09139 6.03921L11.7856 12.4964ZM11.9402 11.7139L11.935 11.7086L6.28959 6.03144C6.2299 5.98708 6.14862 5.98965 6.0914 6.0392L11.9402 11.7139ZM11.9402 11.7139L11.9457 11.7191M11.9402 11.7139L11.9457 11.7191M11.9457 11.7191C12.0139 11.7837 12.0179 11.8948 11.9534 11.9645L11.9457 11.7191Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundIcon);
export default __webpack_public_path__ + "static/media/closeRoundIcon.866a63fe3df29b96550f2b390adb2557.svg";
export { ForwardRef as ReactComponent };